import { useQueryParams } from '@terminal/hooks/use-query-params/useQueryParams';
import { queryKeys, queryValues } from '@terminal/routes/query-params';
import { SubTabsType } from '@terminal/widgets/theme-widget/ThemeWidget';

export const useCompetitorsDrawer = () => {
  const { deleteQueryParam, setQueryParams, params } = useQueryParams();
  const competitorTag = params[queryKeys.competitorTag];
  const isDrawerOpen =
    params[queryKeys.activeDrawer] === queryValues.competitorsDrawer;

  const openDrawer = (competitorTag: string) =>
    setQueryParams({
      [queryKeys.activeDrawer]: queryValues.competitorsDrawer,
      [queryKeys.activeDrawerTab]: SubTabsType.CompetitorOverview,
      [queryKeys.competitorTag]: competitorTag,
    });

  const closeDrawer = () =>
    deleteQueryParam([
      queryKeys.activeDrawer,
      queryKeys.activeDrawerTab,
      queryKeys.competitorTag,
    ]);

  return {
    closeDrawer,
    openDrawer,
    isDrawerOpen,
    competitorTag,
  };
};
